import React, { useState } from "react";
import './AchatQuotaModal.css';

export default function AchatQuotaModal({ isOpen, onClose, line, lines = [], fournisseurs, onSend ,channel = 'EMAIL'}) {
  const [selectedFournisseur, setSelectedFournisseur] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // 🟢 LOGIQUE UNIFIÉE : Si 'line' existe, on en fait un tableau. Sinon on utilise 'lines'.
  const targetLines = line ? [line] : (lines || []);
  
  // La modale ne s'affiche que si elle est ouverte ET qu'il y a au moins 1 produit
  if (!isOpen || targetLines.length === 0) return null;

  const isMassMode = targetLines.length > 1;

  const handleSend = async () => {
    if (!selectedFournisseur) {
      alert("Veuillez sélectionner un fournisseur");
      return;
    }

    setLoading(true);
    try {
      // 🟢 On envoie TOUJOURS un format cohérent au parent
      const payloadToSend = {
        fournisseurId: selectedFournisseur,
        message: message,
        lines: targetLines.map(l => ({
          lineId: l.id, // Gardé pour compatibilité
          reference: l.reference,
          refFabricant: l.refFabricant,
          ean: l.ean,
          quantity: l.quantity
        }))
      };

      await onSend(payloadToSend);
      onClose();
    } catch (err) {
      console.error(err);
      alert("Erreur lors de l'envoi du quota");
    }
    setLoading(false);
  };

  return (
    <div className="quota-overlay">
      <div className="quota-modal">
        <h2>
          {channel === 'WHATSAPP' 
            ? `Envoyer quota par WhatsApp (${targetLines.length} produit${targetLines.length > 1 ? 's' : ''})` 
            : `Envoyer quota par Email (${targetLines.length} produit${targetLines.length > 1 ? 's' : ''})`}
        </h2>

        <div className="quota-body">
          <div className="quota-field">
            <label>Fournisseur</label>
            <select value={selectedFournisseur} onChange={(e) => setSelectedFournisseur(e.target.value)} disabled={loading}>
              <option value="">-- choisir --</option>
              {fournisseurs.map((f) => (
                <option key={f.id} value={f.id}>{f.nom}</option>
              ))}
            </select>
            {fournisseurs.length === 0 && (
  <div style={{ color: '#c62828', fontSize: '13px', marginTop: '6px' }}>
    Aucun fournisseur disponible.
  </div>
)}
          </div>

          <div className="quota-field">
            <label>Message (optionnel)</label>
            <textarea 
              value={message} 
              onChange={(e) => setMessage(e.target.value)} 
              rows={3} 
              disabled={loading}
              style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
              placeholder="Ex: Merci de confirmer le délai de livraison..."
            />
          </div>

          <div className="quota-email-preview">
            <p className="quota-email-header">{new Date().toLocaleDateString()}</p>
            <p><b>Objet :</b> {isMassMode ? `Demande de devis – ${targetLines.length} produits` : `Demande de devis – ${targetLines[0].reference}`}</p>
            <p>Madame, Monsieur,</p>
            <p>{isMassMode ? "Nous souhaitons obtenir un devis pour les produits suivants :" : "Nous souhaitons obtenir un devis pour le produit suivant :"}</p>
            
            {targetLines.map((l, idx) => (
              <div key={l.id || idx} style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '4px', borderLeft: '3px solid #4CAF50' }}>
                {isMassMode && <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#2c3e50' }}>Produit {idx + 1}</p>}
                <ul style={{ margin: 0, paddingLeft: '20px' }}>
                  <li><b>Référence :</b> {l.reference || 'N/A'}</li>
                  {l.refFabricant && <li><b>Ref. Fabricant :</b> {l.refFabricant}</li>}
                  {l.ean && <li><b>EAN :</b> {l.ean}</li>}
                  <li><b>Quantité :</b> {l.quantity}</li>
                </ul>
              </div>
            ))}

            <p>Merci de bien vouloir nous confirmer :</p>
            <ul>
              <li>La disponibilité</li>
              <li>Le prix HT et TTC</li>
              <li>Le délai de livraison</li>
              <li>Les modalités de paiement</li>
            </ul>
            <p>Cordialement,</p>
            <p className="quota-signature">Votre Nom<br />BeepoBuy</p>
          </div>

          <div className="quota-actions">
            <button className="quota-btn quota-btn-cancel" onClick={onClose} disabled={loading}>Annuler</button>
            <button className="quota-btn quota-btn-send" onClick={handleSend} disabled={loading}>
              {loading ? "Envoi..." : `Envoyer (${targetLines.length} produit${targetLines.length > 1 ? 's' : ''})`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}